import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { ShellApi } from './shell-api.interface';
import { getAccountsResMock } from '../mocks/account.mock';
import { GetAccountsRes } from '../models';

@Injectable()
export class ShellApiMockService implements ShellApi {
  getAccounts(): Observable<GetAccountsRes> {
    return of(getAccountsResMock).pipe(delay(500));
  }
}
